import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdAdd } from 'react-icons/md';
// import { exportToExcel } from './xlsxLibrary';
import { exportToExcel } from '../../lib/xlsx/xlsxLibrary';
import { getComponentWeightPerConveyor } from '../conveyor-component/ComponentList';
import { conveyorWeightTotal } from '../conveyor-structure/StructureList';

const ConveyorListActionButtons = () => {
    const project = useSelector((state) => state.project.project);
    const conveyors = useSelector((state) => state.conveyors.conveyors);
    const user = useSelector((state) => state.user.user);

    const language = useSelector(state => state.language.language);
    const isEN = language === 'EN' ? true : false;
    const isJP = language === 'JP' ? true : false;

    if (!conveyors) return;

    const ownProject = (user && user._id) === (project && project.user._id);

    /* Excel Export를 위해 conveyors Data를 가공해야 한다. <- 안할 수는 없나??? */
    const exportData = dataConvert(conveyors);
    const projectName = project?.title;
    const filename = `Specification Table_${projectName}.xlsx`;

    return (
        <ConveyorListActionButtonsBlock>
            {ownProject && (
                <>
                    <StyledLink to="/write/conveyor">
                        {isEN ? 'Add Conveyor' : isJP ? 'コンベヤ追加' : '컨베이어 추가'}
                        <MdAdd />
                    </StyledLink>
                    <StyledButton onClick={() => exportToExcel(exportData, filename)}>
                        Download Excel File(.xlsx)
                    </StyledButton>
                </>
            )}
        </ConveyorListActionButtonsBlock>
    );
};

export default ConveyorListActionButtons;

/* =================   Styles   ================== */
const ConveyorListActionButtonsBlock = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
`;

const StyledLink = styled(Link)`
    padding: 0.25rem 1rem 0.35rem;
    border-radius: 2px;
    border: 1px solid transparent;
    background-color: ${palette.orange};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.orange};
        border: 1px solid ${palette.orange};
        transition: 0.3s;
    }
`;

const StyledButton = styled.button`
    padding: 0.25rem 1rem 0.35rem;
    border: 1px solid transparent;
    border-radius: 2px;
    background-color: ${palette.gray[6]};
    color: white;
    font-size: 0.9rem;
    font-weight: 600;
    text-align: center;
    &:hover {
        background-color: #fff;
        color: ${palette.gray[6]};
        border: 1px solid ${palette.gray[6]};
        transition: 0.3s;
        cursor: pointer;
    }
`;

/* =================   Excel Export   ================== */
const dataConvert = (conveyors) => {
    let data = [];
    conveyors.map((conveyor) => data.push(rowGenerator(conveyor)));
    return data;
};

const rowGenerator = (conveyor) => {
    if (!conveyor.body) return;
    const { input, output, resistance, drives, belt, pulleys, fluidCouplings, gearCouplings, brakes, backstops, structure } = conveyor.body;

    if (!Array.isArray(drives)) {
        return;
    }

    return {
        'BC\r\nNo.': `${conveyor.title || ''}`,
        // Profile: `${input.length || ''}`,
        'H.L\r\n(m)': `${input.length || ''}`,
        'V.L\r\n(m)': `${input.height || ''}`,
        'Capa.\r\n(tph)': `${input.capacity || ''}`,
        'Mtl': `${input.materialConveyed || ''}`,
        'Density\r\n(kg/m3)': `${input.specificGravity || ''}`,
        'Sur-\r\ncharge\r\n(deg.)': `${input.surchargeAngle || ''}`,
        'Belt\r\nWidth\r\n(mm)': `${input.beltWidth || ''}`,
        'Speed\r\n(m/s)': `${input.beltSpeed || ''}`,
        'Tractive\r\nPull\r\n(N)': `${resistance.overall.load || ''}`,
        'Drive ID.': `${drives.map((drive) => drive.description || '').join('\r\n')}`,
        'Drive\r\nEff.': `${drives.map((drive) => drive.mechanicalEfficiency || '').join('\r\n')}`,
        'Req.\r\nPower\r\n(kW)': `${drives.map((drive) => drive.requiredPower || '').join('\r\n')}`,
        'Selected\r\nMotor\r\n(kW)': `${drives.map((drive) => drive.selectedMotor || '').join('\r\n')}`,
        Poles: `${drives.map((drive) => drive.poles || '').join('\r\n')}`,
        'Wrap\r\nAngle\r\n(deg.)': `${drives.map((drive) => drive.wrapAngle || '').join('\r\n')}`,
        'Lagging\r\nfriction\r\ncoeff.': `${drives.map((drive) => drive.frictionCoeff || '').join('\r\n')}`,
        'Driving\r\nFactor': `${drives.map((drive) => drive.drivingFactor || '').join('\r\n')}`,
        'T1\r\n(N)': `${drives.map((drive) => drive.tightSideTension.load || '').join('\r\n')}`,
        'T2\r\n(N)': `${drives.map((drive) => drive.slackSideTension.load || '').join('\r\n')}`,
        'Max\r\nTension\r\n(N)': `${belt?.maxTension || ''}`,
        'KNW\r\n(kN/m)': `${belt?.unitBeltTension || ''}`,
        'Selected Belt': `${belt?.selectedBelt || ''}`,
        SF: `${belt?.actualBeltSF || ''}`,
        'Wb\r\n(kg/m)': `${output?.massBelt || ''}`,
        'Drive\r\nPulley\r\nDia(mm)': `${pulleys.map(pulley => pulley.diaWithLagging || '').join('\r\n')}`,
        'Fluid\r\nCoup.': `${fluidCouplings.map(fluidCoupling => fluidCoupling.selectedFluidCoupling || '').join('\r\n')}`,
        'Gear\r\nCoup.': `${gearCouplings.map(gearCoupling => gearCoupling.model || '').join('\r\n')}`,
        Brake: `${brakes.map(brake => brake.model || '').join('\r\n')}`,
        'Hold\r\nback': `${backstops.map(backstop => backstop.model || '').join('\r\n')}`,
        'Comp.\r\nWt\r\n(ton)': `${getComponentWeightPerConveyor(conveyor) || ''}`,
        'Struct.\r\nWt\r\n(ton)': `${conveyorWeightTotal(structure?.summary) || ''}`,
    };
};
